// extracted by mini-css-extract-plugin
module.exports = {"container":"Payroll_container__3tpJ7","content":"Payroll_content__1-ngP","fade":"Payroll_fade__3Dqfl","labels":"Payroll_labels__2Ud2H","label":"Payroll_label__b38uh"};